import _join from "lodash/join";

export function commaJoin(arr?: string[] | null, separator?: string): string {
  return _join(arr, separator || ", ");
}
